// ----------------------------------------------------------------------------
// Nombre del Programa : Analiticos
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el listado de analitics
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// Se agrego funcionalidad para mostrar el reporte de enlaces 14/JUL/2024
// Se modificaron etiquetas 20/AGO/2024
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import moment from "moment";
import { useEffect, useState } from "react";
import { Row, Col, Table, Form, Button, Container } from "react-bootstrap";
import {
  DatosGrafica,
  EstadisticaComunicado,
} from "../../interfaces/analiticosInterfaces";
import { apiRequestToken } from "../../Utilidades/apiRequest";
import exportFromJSON from "export-from-json";
import { EstadisticasComunicado } from "./EstadisticasComunicado";
import { Graficos } from "./Graficas";
import { Paginador } from "../../components/paginador/Paginador";

export const Analiticos = () => {
  const PAGE_SIZE = 20;
  const [datosCSV, setDatosCSV] = useState<any[]>([]);
  const [datosDia, setDatosDia] = useState<DatosGrafica[]>([]);
  const [datosHora, setDatosHora] = useState<DatosGrafica[]>([]);
  const [datosFecha, setDatosFecha] = useState<DatosGrafica[]>([]);
  const [estadisticas, setEstadisticas] = useState<EstadisticaComunicado[]>([]);
  const [likes, setLikes] = useState<any[]>([]);
  const [estadisticaSeleccionada, setEstadisticaSeleccionada] =
    useState<EstadisticaComunicado>();
  const [pagActual, setPagActual] = useState<number>(0);
  const [dateDesde, setDateDesde] = useState("");
  const [dateHasta, setDateHasta] = useState("");
  const [TipoSeleccionado, setTipoSeleccionado] = useState("1");
  useEffect(() => {
    setDateDesde(moment().subtract(1, "months").format("yyyy-MM-DD"));
    setDateHasta(moment().format("yyyy-MM-DD"));
  }, []);
  const comunicadosMostrados = () =>
    estadisticas.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

    const likesMostrados = () =>
      likes.filter(
        (_, i) =>
          i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
      );
  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const descargarReporte = async () => {
    let fileName = "reporte";
    const exportType = exportFromJSON.types.csv;
    const datosImprimir: any[] = [];
    datosCSV.forEach((item) => {
      if (TipoSeleccionado === "1") {
        datosImprimir.push({
          comunicado_id: item.comunicado_id,
          titulo: item.titulo,
          fechaPublicacion: item.fecha_publicacion,
          fecha_finalizacion: item.fecha_finalizacion,
          fecha: item.fecha,
          hora: item.hora,
          dia_semana: item.dia_semana,
          nombre_evento: item.nombre_evento,
          numero_eventos: item.numero_eventos,
        });
      } else if (TipoSeleccionado === "2") {
        datosImprimir.push({
          enlace_id: item.comunicado_id,
          titulo: item.titulo,
          tipo: item.principal ? "Enlace directo" : "Conéctate",
          fechaPublicacion: item.fecha_publicacion,
          fecha: item.fecha,
          hora: item.hora,
          dia_semana: item.dia_semana,
          nombre_evento: item.nombre_evento,
          numero_eventos: item.numero_eventos,
        });
      }else{
        
        fileName ="likes_dislikes"
        
        datosImprimir.push({
          enlace_id: item.comunicado_id,
          titulo: item.titulo,
          fechaPublicacion: moment(item.fechaPublicacion).format("YYYY-MM-DD"),
          fechaFinalizacion: moment(item.fechaFinalizacion).format("YYYY-MM-DD"),
          likes: item.likes,
          dislikes:item.dislikes
        });
      }
    });
    exportFromJSON({ data: datosImprimir, fileName, exportType });
  };

  const cargarComunicados = async () => {
    let nombreEventoVisto;

    if (TipoSeleccionado === "1") {
      nombreEventoVisto = "comunicado_visto";
    } else if (TipoSeleccionado === "2") {
      nombreEventoVisto = "enlace_visto";
    } else {
      nombreEventoVisto = "likes_visto";
    }

    let params = "";
    params +=
      dateDesde !== ""
        ? "&fechainicio=" + moment(dateDesde).format("YYYY-MM-DD")
        : "";
    params +=
      dateHasta !== ""
        ? //? '&fechafin=' + moment(dateHasta).add(1, 'd').format('YYYY-MM-DD')
          "&fechafin=" + moment(dateHasta).format("YYYY-MM-DD")
        : "";

    let endpoint;
    if (TipoSeleccionado === "1") {
      endpoint = `estadisticas/csv?${params}`;
    } else if (TipoSeleccionado === "2") {
      endpoint = `estadisticasEnlaces/csv?${params}`;
    } else {
      endpoint = `estadisticasLikes/csv?${params}`;
    }

    const response: any = await apiRequestToken({
      endpoint: endpoint,
      method: "GET",
    }).catch(() => {});

    if (response.data?.data) {

      const comunicados: any[] = [];
      const data = response.data.data;

      if (TipoSeleccionado === "2") {
        var elementcont = 0;
        data.forEach(() => {
          data[elementcont].comunicado_id = data[elementcont].enlace_id;
          data[elementcont].titulo = data[elementcont].nombre;
          elementcont++;
        });
      }
      data.forEach((item) => {
        if (TipoSeleccionado === "1") {
          item.principal = true;
        }
        if (
          !comunicados.some(
            (c) => c.comunicado.comunicado_id === item.comunicado_id
          )
        ) {
          comunicados.push({
            comunicado: {
              comunicado_id: item.comunicado_id,
              titulo: item.titulo,
              fechaPublicacion: item.fecha_publicacion,
              fechaCierre: item.fecha_finalizacion,
              principal: item.principal,
            },
            vistas: data.reduce((acc, val) => {
              if (
                val.comunicado_id === item.comunicado_id &&
                val.nombre_evento === nombreEventoVisto
              ) {
                return acc + val.numero_eventos;
              }
              return acc;
            }, 0),
            descargas: data.reduce((acc, val) => {
              if (
                val.comunicado_id === item.comunicado_id &&
                val.nombre_evento === "comunicado_adjunto"
              ) {
                return acc + val.numero_eventos;
              }
              return acc;
            }, 0),
            clics: data.reduce((acc, val) => {
              if (
                val.comunicado_id === item.comunicado_id &&
                val.nombre_evento === "comunicado_link"
              ) {
                return acc + val.numero_eventos;
              }
              return acc;
            }, 0),
          });
        }
      });
      setEstadisticas(comunicados);

      const datosPorDia: any[] = [];
      const datosPorFecha: any[] = [];
      const datosPorHora: any[] = [];
      if (TipoSeleccionado === "1") {
        datosPorDia.push(
          { evento: "Vistas", origin: nombreEventoVisto, datos: [] },
          {
            evento: "Descargas adjuntos",
            origin: "comunicado_adjunto",
            datos: [],
          },
          { evento: "Clics en links", origin: "comunicado_link", datos: [] }
        );
        datosPorFecha.push(
          { evento: "Vistas", origin: nombreEventoVisto, datos: [] },
          {
            evento: "Descargas adjuntos",
            origin: "comunicado_adjunto",
            datos: [],
          },
          { evento: "Clics en links", origin: "comunicado_link", datos: [] }
        );
        datosPorHora.push(
          { evento: "Vistas", origin: nombreEventoVisto, datos: [] },
          {
            evento: "Descargas adjuntos",
            origin: "comunicado_adjunto",
            datos: [],
          },
          { evento: "Clics en links", origin: "comunicado_link", datos: [] }
        );
      } else if (TipoSeleccionado === "2") {
        datosPorDia.push({
          evento: "Vistas",
          origin: nombreEventoVisto,
          datos: [],
        });
        datosPorFecha.push({
          evento: "Vistas",
          origin: nombreEventoVisto,
          datos: [],
        });
        datosPorHora.push({
          evento: "Vistas",
          origin: nombreEventoVisto,
          datos: [],
        });
      } else {
      }

      if (TipoSeleccionado !== "3") {
        data.forEach((item) => {
          // Por Fecha
          let evento = datosPorFecha.find(
            (d) => d.origin === item.nombre_evento
          );
          let dimension = evento.datos.find((d) => d.dimension === item.fecha);
          if (dimension) {
            dimension.conteo += item.numero_eventos;
          } else {
            evento.datos.push({
              dimension: item.fecha,
              conteo: item.numero_eventos,
            });
          }

          // Por Hora

          evento = datosPorHora.find((d) => d.origin === item.nombre_evento);
          dimension = evento.datos.find((d) => d.dimension === item.hora);
          if (dimension) {
            dimension.conteo += item.numero_eventos;
          } else {
            evento.datos.push({
              dimension: item.hora,
              conteo: item.numero_eventos,
            });
          }

          // Dia Semana

          evento = datosPorDia.find((d) => d.origin === item.nombre_evento);
          dimension = evento.datos.find((d) => d.dimension === item.dia_semana);
          if (dimension) {
            dimension.conteo += item.numero_eventos;
          } else {
            evento.datos.push({
              dimension: item.dia_semana,
              conteo: item.numero_eventos,
            });
          }
        });

        setDatosDia(datosPorDia);
        setDatosFecha(datosPorFecha);
        setDatosHora(datosPorHora);
       
      }else{

        setLikes(data)
      }

      setDatosCSV(data);

    }
  };

  //aqui va

  const seleccionarEstadistica = (estadistica) => {
    setEstadisticaSeleccionada(estadistica);
  };

  const cerrarDetalle = () => {
    setEstadisticaSeleccionada(undefined);
  };

  const tipoSeleccionadoUsuario = (event: any) => {
    console.log(event.target.value);

    setTipoSeleccionado(event.target.value);
  };

  useEffect(() => {
    if (dateDesde && dateHasta && TipoSeleccionado) cargarComunicados();
  }, [dateDesde, dateHasta, TipoSeleccionado]);

  return (
    <div className="m-5">
      <Row>
        <Col className="heading-1">Estadísticas</Col>
      </Row>
      <Row className="mt-3">
        <Col sm={2}>
          <label>Desde</label>
          <Form.Control
            type="date"
            name="datepicd"
            placeholder="Desde"
            className="colorgray2"
            value={dateDesde}
            onChange={(e) => setDateDesde(e.target.value)}
          />
        </Col>
        <Col sm={2}>
          <label>Hasta</label>
          <Form.Control
            type="date"
            name="datepich"
            placeholder="Hasta"
            className="colorgray2"
            value={dateHasta}
            onChange={(e) => setDateHasta(e.target.value)}
          />
        </Col>
        <Col sm={3}>
          <label>Tipo reporte</label>
          <Form.Select
            className="colorwhite"
            value={TipoSeleccionado}
            onChange={tipoSeleccionadoUsuario}
          >
            <option value="1">Comunicados</option>
            <option value="2">Enlaces</option>
            <option value="3">Likes Dislikes</option>
          </Form.Select>
        </Col>
        <Col sm={5}>
          <Button
            variant="primary"
            className="float-end"
            onClick={() => descargarReporte()}
          >
            <span className="material-icons">download</span>Descargar CSV
          </Button>
        </Col>
      </Row>
      {!estadisticaSeleccionada ? (
        <>
          <Row className="mt-3">
            <Col>
              {TipoSeleccionado === "1" && (
                <Table responsive>
                  <thead className="colorgray2">
                    <tr>
                      <th>Comunicado</th>
                      <th>Fecha de publicación</th>
                      <th>Fecha de finalización</th>
                      <th>Vistas</th>
                      <th>Descargas adjuntos</th>
                      <th>Clics en links</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comunicadosMostrados().length > 0 &&
                      comunicadosMostrados().map((estadistica, index) => (
                        <tr
                          key={estadistica.comunicado.comunicado_id}
                          className="colorgray2"
                        >
                          <td
                            className="link"
                            onClick={() => seleccionarEstadistica(estadistica)}
                          >
                            {estadistica.comunicado.titulo}
                          </td>
                          <td>
                            {moment(estadistica.comunicado.fechaPublicacion)
                              .utc()
                              .format("DD/MM/YYYY")}
                          </td>
                          <td>
                            {estadistica.comunicado.fechaCierre
                              ? moment(estadistica.comunicado.fechaCierre)
                                  .utc()
                                  .format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td>{estadistica.vistas}</td>
                          <td>{estadistica.descargas}</td>
                          <td>{estadistica.clics}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {TipoSeleccionado === "2" && (
                <Table responsive>
                  <thead className="colorgray2">
                    <tr>
                      <th>Enlace</th>
                      <th>Tipo enlace</th>
                      <th>Fecha de creación</th>
                      <th>Vistas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comunicadosMostrados().length > 0 &&
                      comunicadosMostrados().map((estadistica, index) => (
                        <tr
                          key={estadistica.comunicado.comunicado_id}
                          className="colorgray2"
                        >
                          <td
                            className="link"
                            onClick={() => seleccionarEstadistica(estadistica)}
                          >
                            {estadistica.comunicado.titulo}
                          </td>
                          <td>
                            {estadistica.comunicado.principal
                              ? "Enlace directo"
                              : "Conéctate"}
                          </td>
                          <td>
                            {estadistica.comunicado.fechaPublicacion
                              ? moment(estadistica.comunicado.fechaPublicacion)
                                  .utc()
                                  .format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td>{estadistica.vistas}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {TipoSeleccionado === "3" && (
                <Table responsive>
                  <thead className="colorgray2">
                    <tr>
                      <th>Comunicado</th>
                      <th>Fecha de publicación</th>
                      <th>Fecha de finalización</th>
                      <th>Likes</th>
                      <th>Dislikes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {likesMostrados().length > 0 &&
                      likesMostrados().map((estadistica, index) => (
                        <tr
                          key={estadistica.comunicado_id}
                          className="colorgray2"
                        >
                          <td
                          >
                            {estadistica.titulo}
                          </td>
                          <td>
                            {moment(estadistica.fechaPublicacion)
                              .utc()
                              .format("DD/MM/YYYY")}
                          </td>
                          <td>
                            {estadistica.fechaFinalizacion
                              ? moment(estadistica.fechaFinalizacion)
                                  .utc()
                                  .format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td>{estadistica.likes}</td>
                          <td>{estadistica.dislikes}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}
            </Col>
          </Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={estadisticas.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
          {TipoSeleccionado !== "3" && (
          <Graficos
            datosDia={datosDia}
            datosFecha={datosFecha}
            datosHora={datosHora}
          ></Graficos>)}
        </>
      ) : (
        <EstadisticasComunicado
          estadistica={estadisticaSeleccionada}
          fechaInicio={dateDesde}
          fechaFin={dateHasta}
          tipoSeleccionado={TipoSeleccionado}
          cerrarDetalle={cerrarDetalle}
        ></EstadisticasComunicado>
      )}
    </div>
  );
};
//Modificacion: Marca de Fin WII C-24-1229-24
